function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { useCallback, useState } from 'react';
import debounce from 'lodash.debounce';

function changeShopifyCart(_x) {
  return _changeShopifyCart.apply(this, arguments);
}

function _changeShopifyCart() {
  _changeShopifyCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(lineItem) {
    var res;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return window.fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify(lineItem)
            });

          case 2:
            res = _context4.sent;

            if (res.ok) {
              _context4.next = 11;
              break;
            }

            _context4.t0 = Error;
            _context4.t1 = "Failed to change the cart: Status: ".concat(res.status, " Body: ");
            _context4.next = 8;
            return res.text();

          case 8:
            _context4.t2 = _context4.sent;
            _context4.t3 = _context4.t1.concat.call(_context4.t1, _context4.t2);
            throw new _context4.t0(_context4.t3);

          case 11:
            _context4.next = 13;
            return res.json();

          case 13:
            return _context4.abrupt("return", _context4.sent);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _changeShopifyCart.apply(this, arguments);
}

export function updateShopifyCart(_x2) {
  return _updateShopifyCart.apply(this, arguments);
}

function _updateShopifyCart() {
  _updateShopifyCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(updates) {
    var res;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return window.fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify(updates)
            });

          case 2:
            res = _context5.sent;

            if (res.ok) {
              _context5.next = 11;
              break;
            }

            _context5.t0 = Error;
            _context5.t1 = "Failed to update the cart: Status: ".concat(res.status, " Body: ");
            _context5.next = 8;
            return res.text();

          case 8:
            _context5.t2 = _context5.sent;
            _context5.t3 = _context5.t1.concat.call(_context5.t1, _context5.t2);
            throw new _context5.t0(_context5.t3);

          case 11:
            _context5.next = 13;
            return res.json();

          case 13:
            return _context5.abrupt("return", _context5.sent);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _updateShopifyCart.apply(this, arguments);
}

function addToShopifyCart(_x3) {
  return _addToShopifyCart.apply(this, arguments);
}

function _addToShopifyCart() {
  _addToShopifyCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(items) {
    var res, _yield$res$json, added;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return window.fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                items: items
              })
            });

          case 2:
            res = _context6.sent;

            if (res.ok) {
              _context6.next = 11;
              break;
            }

            _context6.t0 = Error;
            _context6.t1 = "Failed to add items to cart: Status: ".concat(res.status, " Body: ");
            _context6.next = 8;
            return res.text();

          case 8:
            _context6.t2 = _context6.sent;
            _context6.t3 = _context6.t1.concat.call(_context6.t1, _context6.t2);
            throw new _context6.t0(_context6.t3);

          case 11:
            _context6.next = 13;
            return res.json();

          case 13:
            _yield$res$json = _context6.sent;
            added = _yield$res$json.items;
            console.debug('Added to cart', added);
            return _context6.abrupt("return", added);

          case 17:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _addToShopifyCart.apply(this, arguments);
}

export function appendSessionToCart(_x4, _x5, _x6) {
  return _appendSessionToCart.apply(this, arguments);
}

function _appendSessionToCart() {
  _appendSessionToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(cart, sessionId, agentId) {
    var _ref4, _ref5, firstCartItem, key, quantity, properties, cartChanges;

    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _ref4 = (cart === null || cart === void 0 ? void 0 : cart.items) || [], _ref5 = _slicedToArray(_ref4, 1), firstCartItem = _ref5[0];

            if (firstCartItem) {
              _context7.next = 4;
              break;
            }

            console.debug('Unable to append session to cart. No items exist in cart.', {
              cart: cart
            });
            return _context7.abrupt("return", null);

          case 4:
            if (!(!sessionId || !agentId)) {
              _context7.next = 7;
              break;
            }

            console.error('Unable to append session to cart. Missing session or agent id.', {
              sessionId: sessionId,
              agentId: agentId
            });
            return _context7.abrupt("return", null);

          case 7:
            key = firstCartItem.key, quantity = firstCartItem.quantity, properties = firstCartItem.properties;
            _context7.next = 10;
            return changeShopifyCart({
              id: key,
              quantity: quantity,
              properties: _objectSpread(_objectSpread({}, properties), {}, {
                _cpSessionId: sessionId,
                _cpAgentId: agentId
              })
            });

          case 10:
            cartChanges = _context7.sent;
            console.log('Appended session to cart', {
              sessionId: sessionId,
              agentId: agentId,
              cartChanges: cartChanges
            });
            return _context7.abrupt("return", cartChanges);

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _appendSessionToCart.apply(this, arguments);
}

export function fetchShopifyCart() {
  return _fetchShopifyCart.apply(this, arguments);
}

function _fetchShopifyCart() {
  _fetchShopifyCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    var res;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return window.fetch('/cart.js', {
              method: 'GET',
              headers: {
                Accept: 'application/json'
              },
              credentials: 'same-origin'
            });

          case 2:
            res = _context8.sent;

            if (res.ok) {
              _context8.next = 11;
              break;
            }

            _context8.t0 = Error;
            _context8.t1 = "Failed to fetch cart! Status: ".concat(res.status, "  Body: ");
            _context8.next = 8;
            return res.text();

          case 8:
            _context8.t2 = _context8.sent;
            _context8.t3 = _context8.t1.concat.call(_context8.t1, _context8.t2);
            throw new _context8.t0(_context8.t3);

          case 11:
            _context8.next = 13;
            return res.json();

          case 13:
            return _context8.abrupt("return", _context8.sent);

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchShopifyCart.apply(this, arguments);
}

export default function useShopifyCart() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      addedItems = _useState6[0],
      setAddedItems = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      cart = _useState8[0],
      setCart = _useState8[1];

  var addToCart = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(variantQuantities) {
      var freeGifts,
          items,
          freeGiftItems,
          added,
          updatedCart,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              freeGifts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              setLoading(true);
              _context.prev = 2;
              // expects an array of objects with keys quantity and variant
              items = variantQuantities.map(function (_ref2) {
                var _window$btDataLayer, _window$btDataLayer2;

                var quantity = _ref2.quantity,
                    id = _ref2.variant.id,
                    sellingPlanId = _ref2.sellingPlanId;
                var cartItem = {
                  id: id,
                  quantity: quantity,
                  properties: {
                    _cpSessionId: ((_window$btDataLayer = window.btDataLayer) === null || _window$btDataLayer === void 0 ? void 0 : _window$btDataLayer.sessionId) || 'trackers-not-yet-initialized',
                    _cpAgentId: ((_window$btDataLayer2 = window.btDataLayer) === null || _window$btDataLayer2 === void 0 ? void 0 : _window$btDataLayer2.agentId) || 'trackers-not-yet-initialized'
                  }
                };

                if (sellingPlanId) {
                  // eslint-disable-next-line camelcase
                  cartItem.selling_plan = sellingPlanId; // add selling plan id as line item property for tracking purposes on the post-purchase checkout page.
                  //  prefix with underscore to hide from customer on checkout page

                  cartItem.properties = _objectSpread(_objectSpread({}, cartItem.properties), {}, {
                    _sellingPlanId: sellingPlanId
                  });
                }

                return cartItem;
              });
              freeGiftItems = Object.keys(freeGifts).filter(function (variantId) {
                var _window, _window$bt, _window$bt$product, _window$bt$product$in, _window$bt$product$in2;

                return !((_window = window) !== null && _window !== void 0 && (_window$bt = _window.bt) !== null && _window$bt !== void 0 && (_window$bt$product = _window$bt.product) !== null && _window$bt$product !== void 0 && (_window$bt$product$in = _window$bt$product.inCart) !== null && _window$bt$product$in !== void 0 && (_window$bt$product$in2 = _window$bt$product$in.items) !== null && _window$bt$product$in2 !== void 0 && _window$bt$product$in2.find(function (i) {
                  return i.variant_id === Number(variantId);
                }));
              }).map(function (variantId) {
                return {
                  id: Number(variantId),
                  quantity: freeGifts[variantId]
                };
              });
              _context.next = 7;
              return addToShopifyCart([].concat(_toConsumableArray(freeGiftItems), _toConsumableArray(items)));

            case 7:
              added = _context.sent;
              _context.next = 10;
              return fetchShopifyCart();

            case 10:
              updatedCart = _context.sent;
              setCart(updatedCart);
              setAddedItems(added);
              setLoading(false);
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              setError(_context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16]]);
    }));

    return function (_x7) {
      return _ref.apply(this, arguments);
    };
  }(), []); // the updates object must contain key-value pairs where the value is the desired quantity, and the key is the line item's key

  function updateCartAsync(_x8) {
    return _updateCartAsync.apply(this, arguments);
  }

  function _updateCartAsync() {
    _updateCartAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(updatesObject) {
      var updatedCart;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              _context3.prev = 1;
              _context3.next = 4;
              return updateShopifyCart({
                updates: updatesObject
              });

            case 4:
              updatedCart = _context3.sent;
              setCart(updatedCart);
              setLoading(false);
              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](1);
              setError(_context3.t0);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 9]]);
    }));
    return _updateCartAsync.apply(this, arguments);
  }

  var updateCart = useCallback(function (updatesObject) {
    return updateCartAsync(updatesObject);
  }, []);
  var updateCartDebounced = useCallback(debounce(updateCartAsync, 250), []);
  var clearCart = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch('/cart/clear.js');

          case 2:
            res = _context2.sent;

            if (res.ok) {
              _context2.next = 12;
              break;
            }

            _context2.t0 = console;
            _context2.t1 = res.status;
            _context2.next = 8;
            return res.text();

          case 8:
            _context2.t2 = _context2.sent;
            _context2.t3 = {
              status: _context2.t1,
              text: _context2.t2
            };
            _context2.t4 = {
              res: _context2.t3
            };

            _context2.t0.error.call(_context2.t0, 'Failed to clear shopify cart', _context2.t4);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), []);
  return {
    loading: loading,
    error: error,
    addToCart: addToCart,
    addedItems: addedItems,
    updateCart: updateCart,
    updateCartDebounced: updateCartDebounced,
    clearCart: clearCart,
    cart: cart
  };
}